import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

type Props = {
  visible?: boolean
  allPlankList?: any[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    visible: { type: Boolean, default: false },
    allPlankList: { default: () => [] }
  },
  emits: ["handleCancle", "search", "handleBack", "handlePre", "handleNext", "searchConflictingPlates"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'handleCancle'): void
  (e: 'search'): void
  (e: 'handleBack'): void
  (e: 'handlePre', bigPlank: any): void
  (e: 'handleNext', bigPlank: any): void
  (e: 'searchConflictingPlates'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, allPlankList: any[] }



//板件显示初始下标
const num = ref(1)
const allPlankList = ref(props.allPlankList)

const handleBack = () => {
  emits('handleBack')
}
// 上一个
const handleLast = () => {
  // 如果是第一个元素，点击后跳为最后一个元素
  if (num.value === 1) {
    num.value = allPlankList.value.length
  } else num.value -= 1
  emits('handlePre', allPlankList.value[num.value - 1])
}
// 下一个
const handleNext = () => {
  if (num.value === allPlankList.value.length) {
    num.value = 1
  } else {
    num.value += 1
  }
  emits('handleNext', allPlankList.value[num.value - 1])
}
const handleClose = () => {
  emits('handleCancle')
}

return { __sfc: true,emits, props, num, allPlankList, handleBack, handleLast, handleNext, handleClose }
}

})